<template>

  <div class="billmsg">
    <!-- <van-nav-bar title="发票信息"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" /> -->

    <div class='bill_content'>
      <van-tabs>
        <van-tab title="电子普通发票">
          <div class='bill_explain'>
            电子发票即电子增值税发票，是税局认可的有效凭证，其法律效力、基本用途及使用规定同纸质发票。
          </div>
          <div class='bill_main_cont'>
            <div>
              <span>*发票抬头</span>
              <span>个人</span>
            </div>
            <div>
              <span>*发票内容</span>
              <span>日用品</span>
            </div>
            <div>
              <span>*收票人手机</span>
              <span>180****1849</span>
            </div>
            <div>
              <span>*收票人邮箱</span>
              <span>5698401@qq.com</span>
            </div>
          </div>
          <div class='bill_btn'>
            <button>保存</button>
          </div>
        </van-tab>
        <van-tab title="纸质普通发票">
          <div class='bill_explain'>
            <div class='bill_main_cont'>
              <div>
                <span>*收票人手机</span>
                <span>180****1849</span>
              </div>
              <div>
                <span>*收票人邮箱</span>
                <span>5698401@qq.com</span>
              </div>
            </div>
            <div class='bill_btn'>
              <button>保存</button>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div class='bill_know'>
        <p>发票须知</p>
        <ol>
          <li>开票金额为用户实际支付金额（不含礼卡）</li>
          <li>电子发票可在确认收货后，在“订单详情”查看</li>
          <li>未随箱寄出的纸质发票会在收货后15-30个工作日单独寄出</li>
          <li>单笔订单只支持开具一种发票类型，如需增值税专用发票请联系客服处理</li>
          <li>年购订单发票随每期子单寄出</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>

import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { fdatasync } from 'fs';
//import {eventBus} from '../../assets/js/eventBus'

export default {
  name: 'billmsg',
  store,
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" >
.billmsg {
  background: rgb(247, 247, 247);

  & > * {
    font-size: 0.24rem;
  }

  .bill_content {
    height: 100%;
    background: rgb(247, 247, 247);
    padding: 0.3rem;

    .bill_explain {
      font-size: 0.22rem;
      color: #999999;
      padding: 0.36rem 0;
      line-height: 0.35rem;
      background: rgb(247, 247, 247);
    }
    .bill_main_cont {
      & > div {
        height: 0.98rem;
        line-height: 0.98rem;
        border-bottom: 1px solid #f5eded;
        margin: 0 -0.3rem;
        padding: 0 0.3rem;

        & > span {
          display: inline-block;
          &:nth-child(1) {
            color: #999999;
            font-size: 0.28rem;
            width: 1.6rem;
            margin-right: 0.24rem;
            text-align: left;
          }
          &:nth-child(2) {
            color: rgb(51, 51, 51);
            font-size: 0.32rem;
          }
        }
      }
    }
    .bill_btn {
      margin-top: 0.44rem;
      margin-bottom: 0.34rem;
      button {
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: 0.34rem;
        background-color: rgb(255, 144, 0);
        border-radius: 0.2rem;
        border: 1px solid rgb(255, 144, 0);
      }
    }
    .bill_know {
      font-size: 0.22rem;
      color: rgb(153, 153, 153);
      p {
        line-height: 0.4rem;
      }
      ol {
        padding-left: 0.3rem;
        li {
          line-height: 0.4rem;
          list-style: decimal;
        }
      }
    }
  }
  .van-tab {
    color: rgb(153, 153, 153);
    font-size: 0.32rem;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 0.8rem;
  }
  .van-tabs__nav-bar {
    width: 1.88rem !important;
    left: 40px;
    background: rgb(255, 144, 0);
  }
  .van-tab .van-tab--active {
    width: 1.88rem !important;
    .van-ellipsis {
      width: 1.88rem !important;
    }
  }
  .van-tab--active {
    color: rgb(255, 144, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/bill/billmsg.vue